/** @file Zod schema of the editor document (pose2d.doc v1) — the frozen source-of-truth shape. */
import { z } from 'zod';
import { prim } from './schemaParts/primitives';
import { skeletonParts } from './schemaParts/skeleton';
import { attachmentParts } from './schemaParts/attachments';
import { animationParts } from './schemaParts/animation';

export const DocSchema = z
  .object({
    format: z.literal('pose2d.doc'),
    schemaVersion: z.literal(1),
    meta: z.object({ name: prim.name, fps: z.number().int().min(1).max(240), createdAt: z.string(), updatedAt: z.string() }).strict(),
    images: z.record(prim.idOf('img'), skeletonParts.image),
    bones: z.record(prim.idOf('bone'), skeletonParts.bone),
    slots: z.record(prim.idOf('slot'), skeletonParts.slot),
    drawOrder: z.array(prim.idOf('slot')),
    attachments: z.record(prim.idOf('att'), attachmentParts.attachment),
    skins: z.record(prim.idOf('skin'), attachmentParts.skin),
    defaultSkin: prim.idOf('skin'),
    constraints: z.record(prim.idOf('ik'), skeletonParts.constraint),
    events: z.record(prim.idOf('evt'), skeletonParts.event),
    sockets: z.record(prim.idOf('sock'), skeletonParts.socket),
    animations: z.record(prim.idOf('anim'), animationParts.animation),
    mixDefaults: animationParts.mixDefaults.optional(),
    directions: animationParts.directions.optional(),
    references: z.record(prim.idOf('ref'), skeletonParts.reference),
    view: skeletonParts.view,
  })
  .strict();

export type Doc = z.infer<typeof DocSchema>;
